/**
 * Action types for home dashboard graph functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle connected clients graph.
 */

// dashboard group max data usage 
export const AP_DATA_USAGE_GRAPH_API_REQUEST = 'AP_DATA_USAGE_GRAPH_API_REQUEST';
export const AP_DATA_USAGE_GRAPH_API_SUCCESS = 'AP_DATA_USAGE_GRAPH_API_SUCCESS';
export const AP_DATA_USAGE_GRAPH_API_FAIL = 'AP_DATA_USAGE_GRAPH_API_FAIL';
// dashboard group min data usage 
export const AP_MIN_DATA_USAGE_GRAPH_API_REQUEST = 'AP_MIN_DATA_USAGE_GRAPH_API_REQUEST';
export const AP_MIN_DATA_USAGE_GRAPH_API_SUCCESS = 'AP_MIN_DATA_USAGE_GRAPH_API_SUCCESS';
export const AP_MIN_DATA_USAGE_GRAPH_API_FAIL = 'AP_MIN_DATA_USAGE_GRAPH_API_FAIL';
// dashboard group min client 
export const AP_MIN_CLIENT_API_REQUEST = 'AP_MIN_CLIENT_API_REQUEST';
export const AP_MIN_CLIENT_API_SUCCESS = 'AP_MIN_CLIENT_API_SUCCESS';
export const AP_MIN_CLIENT_API_FAIL = 'AP_MIN_CLIENT_API_FAIL';
// dashboard group max client
export const AP_MAX_CLIENT_API_REQUEST = 'AP_MAX_CLIENT_API_REQUEST';
export const AP_MAX_CLIENT_API_SUCCESS = 'AP_MAX_CLIENT_API_SUCCESS';
export const AP_MAX_CLIENT_API_FAIL = 'AP_MAX_CLIENT_API_FAIL';
// ap vendor models
export const VENDOR_MODEL_API_REQUEST = 'VENDOR_MODEL_API_REQUEST';
export const VENDOR_MODEL_API_SUCCESS = 'VENDOR_MODEL_API_SUCCESS';
export const VENDOR_MODEL_API_FAIL = 'VENDOR_MODEL_API_FAIL';
// dashboard ap ssid client count
export const AP_SSID_CLIENT_COUNT_API_REQUEST = 'AP_SSID_CLIENT_COUNT_API_REQUEST';
export const AP_SSID_CLIENT_COUNT_API_SUCCESS = 'AP_SSID_CLIENT_COUNT_API_SUCCESS';
export const AP_SSID_CLIENT_COUNT_API_FAIL = 'AP_SSID_CLIENT_COUNT_API_FAIL';
// dashboard ap ssid data usage
export const AP_SSID_DATA_USAGE_API_REQUEST = 'AP_SSID_DATA_USAGE_API_REQUEST';
export const AP_SSID_DATA_USAGE_API_SUCCESS = 'AP_SSID_DATA_USAGE_API_SUCCESS';
export const AP_SSID_DATA_USAGE_API_FAIL = 'AP_SSID_DATA_USAGE_API_FAIL';
// dashboard ap uptime
export const AP_UPTIME_API_REQUEST = 'AP_UPTIME_API_REQUEST';
export const AP_UPTIME_API_SUCCESS = 'AP_UPTIME_API_SUCCESS';
export const AP_UPTIME_API_FAIL = 'AP_UPTIME_API_FAIL';
// ap site dashboard 5 GHz radio performace api
export const SITE_AP_RADIO_5GH_API_REQUEST = 'SITE_AP_RADIO_5GH_API_REQUEST';
export const SITE_AP_RADIO_5GH_API_SUCCESS = 'SITE_AP_RADIO_5GH_API_SUCCESS';
export const SITE_AP_RADIO_5GH_API_FAIL = 'SITE_AP_RADIO_5GH_API_FAIL';

// ap site dashboard 2.4 GHz radio performace api
export const SITE_AP_RADIO_2GH_API_REQUEST = 'SITE_AP_RADIO_2GH_API_REQUEST';
export const SITE_AP_RADIO_2GH_API_SUCCESS = 'SITE_AP_RADIO_2GH_API_SUCCESS';
export const SITE_AP_RADIO_2GH_API_FAIL = 'SITE_AP_RADIO_2GH_API_FAIL';

// each ap dashboard 5 GHz radio performace api
export const AP_RADIO_5GH_API_REQUEST = 'AP_RADIO_5GH_API_REQUEST';
export const AP_RADIO_5GH_API_SUCCESS = 'AP_RADIO_5GH_API_SUCCESS';
export const AP_RADIO_5GH_API_FAIL = 'AP_RADIO_5GH_API_FAIL';

// each ap dashboard 2.4 GHz radio performace api
export const AP_RADIO_2GH_API_REQUEST = 'AP_RADIO_2GH_API_REQUEST';
export const AP_RADIO_2GH_API_SUCCESS = 'AP_RADIO_2GH_API_SUCCESS';
export const AP_RADIO_2GH_API_FAIL = 'AP_RADIO_2GH_API_FAIL';


// each ap dashboard 5 GHz mcs phy api
export const AP_RADIO_MCS_PHY_5GH_API_REQUEST = 'AP_RADIO_MCS_PHY_5GH_API_REQUEST';
export const AP_RADIO_MCS_PHY_5GH_API_SUCCESS = 'AP_RADIO_MCS_PHY_5GH_API_SUCCESS';
export const AP_RADIO_MCS_PHY_5GH_API_FAIL = 'AP_RADIO_MCS_PHY_5GH_API_FAIL';

// each ap dashboard 2.4 GHz mcs phy api
export const AP_RADIO_MCS_PHY_2GH_API_REQUEST = 'AP_RADIO_MCS_PHY_2GH_API_REQUEST';
export const AP_RADIO_MCS_PHY_2GH_API_SUCCESS = 'AP_RADIO_MCS_PHY_2GH_API_SUCCESS';
export const AP_RADIO_MCS_PHY_2GH_API_FAIL = 'AP_RADIO_MCS_PHY_2GH_API_FAIL';